import { ADD_CART, REMOVE_CART, CHANGE_CART_NAME, SELECT_CART, ADD_ITEM_TO_CART, REMOVE_ITEM_FROM_CART, UPDATE_CART_ITEM, GET_CARTS, COPY_CART, CHANGE_FLOAT_CART_STATE, MANAGE_FAVORITES, FILTER, SORT, ADD_SORT_TAG, RESET_SORT } from './actionTypes';

// Editing starts from here....
export const showCart = carts => ({
    type: GET_CARTS,
    payload: carts
  });
  
  export const addCart = () => ({
    type: ADD_CART
  });
  
  export const removeCart = id => ({
    type: REMOVE_CART,
    payload: {
      id: id
    }
  });
  
  export const updateCartName = (name, id) => ({
    type: CHANGE_CART_NAME,
    payload: {
      name: name,
      id: id
    }
  });
  
  export const selectCart = id => ({
    type: SELECT_CART,
    payload: {
      id: id
    }
  });
  
  export const addItemToCart = item => ({
    type: ADD_ITEM_TO_CART,
    payload: {
      item: item
    }
  });
  
  export const updateCartItem = (bagId, item, action) => ({
    type: UPDATE_CART_ITEM,
    payload: {
      bagId: bagId,
      item: item,
      action: action
    }
  });
  
  export const removeItemFromCart = (bagId, item) => ({
    type: REMOVE_ITEM_FROM_CART,
    payload: {
      bagId: bagId,
      item: item
    }
  });

  export const copyCart = bagId => ({
    type: COPY_CART,
    payload: {
      bagId: bagId
    }
  });

  export const changeFloatCartState = () => ({
    type: CHANGE_FLOAT_CART_STATE,
  });

  export const manageFav = (item) => ({
    type: MANAGE_FAVORITES,
    payload: {
      item: item
    }
  });

  export const changeFilter = filterType => ({
    type: FILTER,
    payload: {
      type: filterType
    }
  })

  export const changeSort = sortType => ({
    type: SORT,
    payload: {
      type: sortType
    }
  })

  export const addToSort = tag => ({
    type: ADD_SORT_TAG,
    payload: {
      tag: tag
    }
  })

  export const resetSort = () => ({
    type: RESET_SORT
  });